import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Container = styled.div`
    margin: 15px 0;
    width: 380px;
    height: 270px;
    ${media.mobileDevice`
        width:310px; 
         `}
`;

export const Message = styled.div`
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '0px')};
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${({ buttonMargin }) =>
        buttonMargin ? buttonMargin : '40px 0 0 0'};
`;
